import { DefaultLower, NullBanner } from "@/model/DefaultBanners";
import { RiskLevel } from "@/model/RiskLevel";
const Increasing = {
    rawCopy: `For Increasing Risk scores we recommend that you cut down your drinking. Click here to <u>book a FREE online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/nenc"
};
const Higher = {
    rawCopy: `For Higher Risk scores we recommend that you cut down your drinking. Click here to <u>book a FREE online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/nenc"
};
const High = {
    rawCopy: `For High Risk /Possible Dependence scores we strongly recommend that you cut down your drinking. Click here to <u>book a FREE online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/nenc"
};
export default {
    name: "NorthEastAndNorthCumbria",
    displayName: "North East and North Cumbria",
    excludeFromNavigation: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: Increasing,
        [RiskLevel.Higher]: Higher,
        [RiskLevel.High]: High
    },
    regions: [
        "County Durham",
        "Cumbria",
        "Darlington",
        "Gateshead",
        "Hartlepool",
        "Middlesbrough",
        "Newcastle",
        "North Tyneside",
        "Northumberland",
        "Redcar & Cleveland",
        "South Tyneside",
        "Stockton",
        "Sunderland",
    ],
};
//# sourceMappingURL=NorthAndNorthEastCumbria.js.map